import { Body, Box, Image } from '@hover/blueprint';
import React, { useEffect, useState } from 'react';

import type { ImageLike } from 'src/modules/renderings/imageLike';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

const ImageThumbnailContainer = ({
  handleTracking,
  heroImageURL,
  handleImageSelect,
  image,
}: {
  handleTracking: Function;
  heroImageURL?: string;
  handleImageSelect: Function;
  image: ImageLike;
}) => {
  const [isSelected, setIsSelected] = useState(false);
  const { blobUrl: fullImageURL, thumbUrl } = image;
  const t = useTranslate(TranslationNamespace.SHARED);

  const label = image.label(t);

  useEffect(() => {
    setIsSelected(fullImageURL === heroImageURL);
  }, [fullImageURL, heroImageURL]);

  const handleClick = (selectedImage: ImageLike) => {
    handleTracking();
    handleImageSelect(selectedImage);
  };

  return (
    <Box
      _hover={{
        borderColor: isSelected ? 'primary.600' : 'primary.200',
        shadow: isSelected ? 'haloPrimary' : undefined,
      }}
      borderColor={isSelected ? 'primary.600' : 'transparent'}
      borderRadius="4px"
      borderStyle="solid"
      borderWidth="2px"
      className="rendering-thumbnail"
      cursor="pointer"
      flexDir="column"
      justifySelf="center"
      margin={50}
      maxWidth={700}
      minWidth={500}
      onClick={() => handleClick(image)}
      position="relative"
      transition="all 0.1s ease-in-out"
      width="100%"
    >
      <Image
        __css={{
          // prevents layout shift while image loads
          aspectRatio: '1.775',
        }}
        alt="rendering"
        backgroundColor="neutral.200"
        borderTopRadius="2px"
        loading="lazy"
        margin={0}
        src={thumbUrl}
      />
      <Box backgroundColor="neutral.0" borderBottomRadius={200} height={300}>
        <Body
          color={isSelected ? 'neutral.text' : 'neutral.textLight'}
          lineHeight={300}
          margin={0}
          noOfLines={1}
          px={200}
          py={100}
          size={300}
        >
          {label}
        </Body>
      </Box>
    </Box>
  );
};

export { ImageThumbnailContainer };
